module.exports = __webpack_public_path__ + "static/media/right.006d40b4.svg";